import React, { useState, useContext, useEffect } from "react";
import { default as translate } from "../../i18n/translate";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import IconButton from '@mui/material/IconButton';
import ConfirmModal from "../forms/ConfirmModal";
import EditIcon from '@mui/icons-material/Edit';
import EditCapsuleForm from "../forms/EditCapsuleForm";
import { AppContext } from "../context";
import { LOCALES } from "../../i18n";
import { KeycloackContext } from "../../services/keycloakProvider";
import { updateCapsule } from "../../services/requestHandler";

function toEmbedUrl(url) {
  if (!url || typeof url !== "string") return "";

  const cleanUrl = url.trim();

  if (cleanUrl.includes("youtube.com/embed/")) {
    return cleanUrl;
  }

  if (cleanUrl.includes("youtube.com/watch?v=")) {
    const videoId = cleanUrl.split("v=")[1]?.split("&")[0];
    return videoId ? `https://www.youtube.com/embed/${videoId}` : "";
  }

  if (cleanUrl.includes("youtu.be/")) {
    const videoId = cleanUrl.split("youtu.be/")[1]?.split("?")[0];
    return videoId ? `https://www.youtube.com/embed/${videoId}` : "";
  }

  if (cleanUrl.includes("youtube.com/shorts/")) {
    const videoId = cleanUrl.split("shorts/")[1]?.split("?")[0];
    return videoId ? `https://www.youtube.com/embed/${videoId}` : "";
  }

  return cleanUrl;
}

export default function CapsuleVideo({ video, handleDelete = () => {} }) {
  const { state } = useContext(AppContext);
  const { isAdminRole } = useContext(KeycloackContext);

  const [confirmOpen, setConfirmOpen] = useState(false);
  const [formOpen, setFormOpen] = useState(false);
  const [videoInfos, setVideoInfos] = useState(video);

  const [videoTitle, setVideoTitle] = useState("");
  const [videoLink, setVideoLink] = useState("");

  useEffect(() => {
    setVideoInfos(video);
  }, [video]);

  useEffect(() => {
    if (state.locale === LOCALES.FRENCH) {
      setVideoTitle(videoInfos?.contenu || "");
      setVideoLink(toEmbedUrl(videoInfos?.arrayLink || ""));
    } else if (state.locale === LOCALES.ENGLISH) {
      setVideoTitle(videoInfos?.contenu_en || "");
      setVideoLink(toEmbedUrl(videoInfos?.arrayLink_en || ""));
    }
  }, [state.locale, videoInfos]);

  const handleDeleteClick = () => {
    handleDelete(videoInfos.id);
  };

  const handleModifyClick = (newVideoInfos) => {
    setVideoInfos(newVideoInfos);

    const newVideo = {
      contenu: newVideoInfos.contenu,
      arrayLink: newVideoInfos.arrayLink,
      contenu_en: newVideoInfos.contenu_en,
      arrayLink_en: newVideoInfos.arrayLink_en,
      no_video: newVideoInfos.no_video,
      id: newVideoInfos.id,
    };

    updateCapsule(newVideo);
  };

  return (
    <div className="video-responsive">
      <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
        {videoLink ? (
          <div><h2>{videoTitle}</h2></div>
        ) : (
          <div><h2>{translate("capsule.non_disponible")}</h2></div>
        )}

        {isAdminRole && videoLink && (
          <IconButton onClick={() => setConfirmOpen(true)} aria-label="DeleteForever">
            <DeleteForeverIcon sx={{ color: "black" }} />
          </IconButton>
        )}

        {isAdminRole && (
          <IconButton onClick={() => setFormOpen(true)} aria-label="Edit">
            <EditIcon sx={{ color: "black" }} />
          </IconButton>
        )}

        {isAdminRole && (
          <ConfirmModal
            content={translate("questionnaire.supprimer_element")}
            open={confirmOpen}
            setOpen={setConfirmOpen}
            onConfirm={handleDeleteClick}
          />
        )}

        {isAdminRole && (
          <EditCapsuleForm
            video={videoInfos}
            open={formOpen}
            setOpen={setFormOpen}
            onConfirm={handleModifyClick}
          />
        )}
      </div>

      {videoLink ? (
        <iframe
          title={videoTitle || "capsule-video"}
          style={{ height: "300px", width: "400px", border: 0 }}
          src={videoLink}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      ) : null}
    </div>
  );
}
